import {ReferencingLayout, LogoGreyCircle, ActionButton} from '@ark/web';
import {useStartReplay} from '@landlord/hooks/useStartReplay';
import {useTrackPageView} from '@landlord/hooks/useTrackPageView';
import {Box, Typography} from '@mui/material';
import lookUnderBed from '@landlord/assets/lookUnderBed.png';
import {StepContent} from '@landlord/pages/Referencing/StepContent';
import {useIntercom} from 'react-use-intercom';

export const ReferenceSignupServiceUnavailable = () => {
  useStartReplay();
  useTrackPageView();

  const intercom = useIntercom();

  return (
    <ReferencingLayout>
      <Box sx={{minHeight: '500px'}}>
        <img
          src={lookUnderBed}
          width="100%"
          height={200}
          style={{
            objectFit: 'cover',
            objectPosition: '50% 30%',
          }}
          alt="person looking under bed"
        />
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            marginTop: '-45px',
          }}
        >
          <LogoGreyCircle />
        </Box>
        <StepContent>
          <Typography variant="h1" mt={2}>
            Service No Longer Available
          </Typography>
          <Typography textAlign="center">
            We apologise for any inconvenience, but we are currently pausing our
            referencing services.
          </Typography>
          <ActionButton
            variant="primary"
            fullWidth
            sx={{mt: 4}}
            onClick={() => {
              intercom.trackEvent('Referencing Service Unavailable Contact');
              intercom.showNewMessage('');
            }}
          >
            Contact Support
          </ActionButton>
        </StepContent>
      </Box>
    </ReferencingLayout>
  );
};
